import React, { useEffect, useRef } from "react";
import utility from "./utility";
import { render as appkitRender } from "./client.mjs";
import { render as appkitServerRender } from "./server.mjs";

// let appkitRender;


const AppKit = ({ data }) => {
  console.log(data);

  const targetRef = useRef(null);
  useEffect(() => {
   // loadScriptOnce("https://media.mediadirhub.com/js/client-devtool.js", function(){
    console.log("Ravi K");
    // appkitRender = window.Ya?.DivKit?.render;
    // renderClientAppKit();
   // })
  //renderClientAppKit();
    
  }, [data]);

  const renderClientAppKit = () => {
    if (appkitRender) {
      console.log("appkitRender");
      const target = targetRef.current || document.querySelector("#divkitHTML");
      if (!target) {
        console.error("Target element #divkitHTML not found");
        return;
      }
      const fonts = Array.from(utility.extractFontFamilies(data));
      targetRef.current.innerHTML = "";
      const renderedHtml = appkitRender({
        id: `test123`,
        json: data,
        //json: JSON.parse(window.webEditor.getCard().json),
        target: target,
        platform: "desktop",
        onSubmit: (action, values) => {
          // self.handleDivKitAction(action,values);
        },
        direction: "ltr",
         typefaceProvider(fontFamily) {
                   return fonts;
        },
        onError: function (event) {
          console.log(event.error,"event.error");
          // console.log('Preview', event.error.message);
        },
        onComponent: function ({ type, node, json }) {
            convertElements(node, json);
        },
      });
    }
  };
  // const divkitHtml = "";
  const fonts = Array.from(utility.extractFontFamilies(data));
  //console.log("extractFontFamilies", fonts);

  const divkitHtml = appkitServerRender({
    json: data,
    id: "divkitHTML",
    platform: "desktop",
    direction: "ltr",
    typefaceProvider(fontFamily) {
                   return fonts;
    },
    onError: (event) => {
      console.error("DivKit SSR Error:", event.error.message);
    },
  });


  const convertIcon = (node, json) => {   
    // Find image element and add tint color as query param
    const img = node.querySelector('img');

    if (img) {
        const currentSrc = img.getAttribute('src');
        img.style.removeProperty("background-color");
        if (currentSrc) {
            // Remove existing color params to avoid duplication
            const cleanSrc = currentSrc.split('?')[0];
            // Add color query param if src exists
            const colorParam = `color=${encodeURIComponent(json.tint_color.replace("#", ""))}`;
            const newSrc = `${cleanSrc}?${colorParam}`;
            img.setAttribute('src', newSrc);
        }
    }
   
}


const convertElements =function(node, json) {
    
    if(json.type === "image" && json.tint_color){
        console.log(json, "json");
        convertIcon(node, json);
    }
}


  return (
    <div className="block appkit-block">
      <link rel="stylesheet" href={utility.getServerSideFontLinks()} />
      <style jsx global>
        {`
          .appkit-root {
            unicode-bidi: unset;
            pointer-events: all;
          }
        `}
      </style>
      <link rel="stylesheet" href='https://media.mediadirhub.com/minify/css/appkit.css?version=1765799974958' />
      <div id="divkitHTML" ref={targetRef} dangerouslySetInnerHTML={{ __html: divkitHtml }} />
    </div>
  );
};

export default AppKit;
